import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import { Input, Button, Card, Modal, Form, message, Select } from 'antd'
// initCurryingObj
import {
  paginationInit,
  formatMessageNew
  // handleChange
} from '@/utils/common'
import { modalConfirm, modalError } from '@/utils/modalUtils'
import {
  getRFDeviceList,
  addRFDevice,
  addRFUpdate,
  changeRFDeviceStatus,
  findFunctionModules
} from '@/services/configuration/config'
import { PlusOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import { hasPermission } from '@/annotations/nike-react'
import moment from 'moment'

// const activeStatusObj = initCurryingObj(ACTIVE_STATUS)
const menu_nfc_configuration_RFDevice = 'menu_nfc_configuration_RFDevice'
const RFDevicePage = () => {
  const [newModalForm] = Form.useForm()
  const selectedFunctionModules = Form.useWatch('functionModule', newModalForm) || []
  let editItemInfo = useRef({})
  let editItemFlag = useRef(false)
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [statusFlag, setStatusFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [functionModuleOptions, setFunctionModuleOptions] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const is1025Module = value => String(value).includes('1025')
  const is1027Module = value => String(value).includes('1027')
  const normalizedSelectedFunctionModules = selectedFunctionModules.map(item => String(item))
  const hasSelected1025 = normalizedSelectedFunctionModules.some(is1025Module)
  const hasSelected1027 = normalizedSelectedFunctionModules.some(is1027Module)
  const disabled1025Options = functionModuleOptions.map(item => ({
    ...item,
    disabled:
      !normalizedSelectedFunctionModules.includes(String(item.value)) &&
      ((hasSelected1027 && is1025Module(item.value)) || (hasSelected1025 && is1027Module(item.value)))
  }))
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.configuration.deviceCode'),
      dataIndex: 'deviceCode'
    },
    {
      title: formatMessageNew('languageObj.configuration.macAddress'),
      dataIndex: 'macAddress'
    },
    {
      title: formatMessageNew('languageObj.configuration.function'),
      dataIndex: 'functionModule'
    },
    {
      title: formatMessageNew('languageObj.configuration.RFDeviceStatus'),
      dataIndex: 'status'
    },
    {
      title: formatMessageNew('languageObj.configuration.createTime'),
      dataIndex: 'createTime',
      render: text => text && moment(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: formatMessageNew('languageObj.configuration.updateTime'),
      dataIndex: 'updateTime',
      render: text => text && moment(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: formatMessageNew('languageObj.commonLocale.operation'),
      dataIndex: 'operation',
      align: 'center',
      render: (text, record) => (
        <div>
          <Button
            disabled={!hasPermission(menu_nfc_configuration_RFDevice)}
            type="link"
            size="small"
            onClick={() => {
              addAndEditRecord(record)
            }}
          >
            {formatMessageNew('languageObj.commonLocale.edit')}
          </Button>
        </div>
      )
    }
  ]

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    findFunctionModulesFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const findFunctionModulesFun = () => {
    findFunctionModules().then(res => {
      let ls = res.resultData.map(item => {
        return {
          label: item,
          value: item
        }
      })
      setFunctionModuleOptions(ls)
    })
  }
  useEffect(() => {
    if (selectedRowKeys.length <= 0 && statusFlag) setStatusFlag(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys])

  const searchDataFun = () => {
    const params = {
      pageNo: pagination.currentPage,
      size: pagination.pageSize,
      total: pagination.total
    }
    getRFDeviceList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const changeStatus = () => {
    const params = {
      ids: selectedRowKeys,
      status: statusFlag ? 'Enabled' : 'Disabled'
    }
    if (statusFlag) {
      requestChangeStatus(params)
      return
    }
    modalConfirm(
      {
        content: formatMessageNew('languageObj.configuration.disableRFDeviceConfirmInfo')
      },
      () => requestChangeStatus(params)
    )
  }

  const requestChangeStatus = params => {
    changeRFDeviceStatus(params).then(res => {
      if (res.errorCode === '200') {
        message.success(formatMessageNew('languageObj.commonLocale.success'))
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      }
    })
  }

  const addDevice = () => {
    // const values = newModalForm.getFieldsValue()
    newModalForm
      .validateFields()
      .then(values => {
        const { deviceCode, macAddress, functionModule } = values
        if (!deviceCode || !macAddress || !functionModule) return
        const params = { deviceCode, macAddress, functionModule }
        params.functionModule = functionModule ? functionModule.join(',') : ''

        if (editItemFlag.current) {
          params.id = editItemInfo.current.id
          params.status = editItemInfo.current.status
          addRFUpdate(params)
            .then(res => {
              if (res.errorCode !== '200') return
              message.success(formatMessageNew('languageObj.commonLocale.success'))
              setQueryFlag(!queryFlag)
              setVisibleFlag(false)
            })
            .catch(err => {
              modalErrorFun(err)
            })
        } else {
          addRFDevice(params)
            .then(res => {
              if (res.errorCode !== '200') return
              message.success(formatMessageNew('languageObj.commonLocale.success'))
              setQueryFlag(!queryFlag)
              setVisibleFlag(false)
            })
            .catch(err => {
              modalErrorFun(err)
            })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const modalErrorFun = err => {
    let title = ''
    let msg = 'languageObj.httpLocale.requestError'
    const errorCode = String(err?.errorCode || '')
    if (errorCode === '2101') {
      title = 'languageObj.configuration.errTitleExist'
      msg = 'languageObj.configuration.errMsgExist'
    } else if (errorCode === '2102') {
      title = 'languageObj.configuration.errTitleMac'
      msg = 'languageObj.configuration.errMsgMac'
    } else if (errorCode === '2103') {
      title = 'languageObj.configuration.errTitleDeviceCode'
      msg = 'languageObj.configuration.errMsgDeviceCode'
    } else if (errorCode === '3005') {
      title = 'languageObj.configuration.errTitleModuleConflict'
      msg = 'languageObj.configuration.errMsgModuleConflict'
    }
    const modalConfig = {
      content: formatMessageNew(msg)
    }
    if (title) {
      modalConfig.title = formatMessageNew(title)
    }
    modalError(modalConfig)
  }

  const hideAddModal = () => {
    newModalForm.resetFields()
    setVisibleFlag(false)
  }

  const addAndEditRecord = record => {
    setVisibleFlag(true)
    if (record) {
      let params = {
        ...record
      }
      params.functionModule = record.functionModule ? record.functionModule.split(',') : []
      editItemFlag.current = true
      editItemInfo.current = params
      newModalForm.setFieldsValue(params)
    } else {
      editItemFlag.current = false
      editItemInfo.current = {}
      newModalForm.resetFields()
    }
  }

  const handleFunctionModuleChange = values => {
    const normalizedValues = values.map(item => String(item))
    const selected1025Values = normalizedValues.filter(is1025Module)
    const selected1027Values = normalizedValues.filter(is1027Module)
    if (!selected1025Values.length || !selected1027Values.length) return
    const keep1027Values = normalizedSelectedFunctionModules.some(is1027Module)
    const filteredValues = values.filter(item => {
      if (keep1027Values) {
        return !is1025Module(item)
      }
      return !is1027Module(item)
    })
    if (filteredValues.length !== values.length) {
      newModalForm.setFieldsValue({ functionModule: filteredValues })
    }
  }

  const onSelectChange = newSelectedRowKeys => {
    const matchedObjects = _.filter(tableList, obj => _.includes(newSelectedRowKeys, obj.id))
    let allFalse = _.every(matchedObjects, ['status', 'Disabled'])
    setStatusFlag(allFalse)
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        {hasPermission(menu_nfc_configuration_RFDevice) && (
          <>
            <Button
              type="primary"
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={() => {
                addAndEditRecord()
              }}
            >
              <PlusOutlined />
              {formatMessageNew('languageObj.configuration.addRFDevice')}
            </Button>
            <Button
              type="primary"
              danger={!statusFlag}
              disabled={!hasSelected}
              style={{ marginLeft: '20px', marginTop: '10px' }}
              onClick={changeStatus}
            >
              {statusFlag
                ? formatMessageNew('languageObj.commonLocale.enable')
                : formatMessageNew('languageObj.commonLocale.disable')}
            </Button>
          </>
        )}
        <div className="content-container">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={hasPermission(menu_nfc_configuration_RFDevice) && rowSelection}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={
          editItemFlag.current
            ? formatMessageNew('languageObj.configuration.editRFDevice')
            : formatMessageNew('languageObj.configuration.addRFDevice')
        }
        onOk={addDevice}
        onCancel={hideAddModal}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          style={{ maxWidth: 680 }}
          autoComplete="off"
        >
          <Form.Item
            label={formatMessageNew('languageObj.configuration.deviceCode')}
            name="deviceCode"
            rules={[{ required: true }]}
          >
            <Input allowClear placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.configuration.macAddress')}
            name="macAddress"
            rules={[{ required: true }]}
          >
            <Input allowClear placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.configuration.function')}
            name="functionModule"
            rules={[{ required: true }]}
          >
            <Select
              onChange={handleFunctionModuleChange}
              allowClear
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              options={disabled1025Options}
              mode="multiple"
            ></Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default RFDevicePage
